<div
  class="modal-overlay"
  tabindex="-1"
  (click)="closeModal()"
  (keydown.enter)="closeModal()"
>
  <div
    class="visibility-modal"
    tabindex="-1"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  >
    <div class="modal-header">
      @if (recordDetails?.visibility_mode === recordVisibilityModes.Public) {
        <app-svg-icon
          [iconName]="'globe.svg'"
          [width]="'18px'"
          [height]="'18px'"
          [style.fill]="'#333'"
        ></app-svg-icon>
      } @else if (
        recordDetails?.visibility_mode === recordVisibilityModes.Private
      ) {
        <app-svg-icon
          [iconName]="'private-lock.svg'"
          [width]="'18px'"
          [height]="'18px'"
          [style.fill]="'#333'"
        ></app-svg-icon>
      } @else if (
        recordDetails?.visibility_mode === recordVisibilityModes.Restricted
      ) {
        <app-svg-icon
          [iconName]="'restricted-users.svg'"
          [width]="'18px'"
          [height]="'18px'"
          [style.fill]="'#333'"
        ></app-svg-icon>
      }
      <h3>Record Visibility Settings</h3>
    </div>

    <div class="modal-body">
      @if (!showConfirmation) {
        <!-- Visibility Options -->
        <div class="visibility-section">
          <h3>Select Visibility Mode</h3>
          @if (hasLead) {
            <div class="info-message">
              <app-svg-icon
                [iconName]="'info.svg'"
                [width]="'20px'"
                [height]="'20px'"
                [style.fill]="'#0066cc'"
              ></app-svg-icon>
              <span
                >Private mode is not available because there are active leads
                for this record.</span
              >
            </div>
          }
          <div class="visibility-options-grid">
            <label
              class="visibility-card"
              [class.selected]="visibilityMode === recordVisibilityModes.Public"
            >
              <input
                type="radio"
                name="visibilityMode"
                [value]="recordVisibilityModes.Public"
                [(ngModel)]="visibilityMode"
              />
              <div class="card-icon">
                <app-svg-icon
                  [iconName]="'globe.svg'"
                  [width]="'20px'"
                  [height]="'20px'"
                  [style.fill]="'#666'"
                ></app-svg-icon>
              </div>
              <div class="card-content">
                <h4>Public</h4>
                <p>Anyone can view this record</p>
              </div>
              <div class="card-check">
                <app-svg-icon
                  [iconName]="'check.svg'"
                  [width]="'20px'"
                  [height]="'20px'"
                  [style.fill]="'#334ea5'"
                ></app-svg-icon>
              </div>
            </label>

            <label
              class="visibility-card"
              [class.selected]="
                visibilityMode === recordVisibilityModes.Private
              "
              [class.disabled]="hasLead"
              [attr.title]="
                hasLead
                  ? 'Cannot set to Private while there are active leads for this record'
                  : ''
              "
            >
              <input
                type="radio"
                name="visibilityMode"
                [value]="recordVisibilityModes.Private"
                [(ngModel)]="visibilityMode"
                [disabled]="hasLead"
              />
              <div class="card-icon">
                <app-svg-icon
                  [iconName]="'private-lock.svg'"
                  [width]="'20px'"
                  [height]="'20px'"
                ></app-svg-icon>
              </div>
              <div class="card-content">
                <h4>Private</h4>
                <p>Only you can view this record</p>
              </div>
              <div class="card-check">
                <app-svg-icon
                  [iconName]="'check.svg'"
                  [width]="'20px'"
                  [height]="'20px'"
                  [style.fill]="'#334ea5'"
                ></app-svg-icon>
              </div>
              @if (hasLead) {
                <div class="disabled-overlay">
                  <app-svg-icon
                    [iconName]="'warning-circle.svg'"
                    [width]="'100%'"
                    [height]="'100%'"
                    [style.fill]="'#856404'"
                  ></app-svg-icon>
                </div>
              }
            </label>

            <label
              class="visibility-card"
              [class.selected]="
                visibilityMode === recordVisibilityModes.Restricted
              "
            >
              <input
                type="radio"
                name="visibilityMode"
                [value]="recordVisibilityModes.Restricted"
                [(ngModel)]="visibilityMode"
              />
              <div class="card-icon mode-restricted">
                <app-svg-icon
                  [iconName]="'restricted-users.svg'"
                  [width]="'20px'"
                  [height]="'20px'"
                ></app-svg-icon>
              </div>
              <div class="card-content">
                <h4>Restricted</h4>
                <p>Share with specific CDFIs</p>
              </div>
              <div class="card-check">
                <app-svg-icon
                  [iconName]="'check.svg'"
                  [width]="'20px'"
                  [height]="'20px'"
                  [style.fill]="'#334ea5'"
                ></app-svg-icon>
              </div>
            </label>
          </div>
        </div>

        <!-- Restricted Mode Connection Selection -->
        @if (visibilityMode === recordVisibilityModes.Restricted) {
          <div class="connections-selection-section">
            <h3>Select CDFI</h3>
            <p class="hint-text">Choose which CDFI can access this record</p>

            <div class="search-input-wrapper">
              <app-svg-icon
                class="search-icon"
                [iconName]="'search-solid.svg'"
                [width]="'16px'"
                [height]="'16px'"
                [style.fill]="'#999'"
              ></app-svg-icon>
              <input
                type="text"
                placeholder="Search CDFI..."
                (input)="onSearchConnection($event)"
                class="search-input"
              />
            </div>

            <div class="connections-list-modal">
              @if (!isLoading) {
                @if (allConnections.length > 0) {
                  @for (connection of allConnections; track $index) {
                    <label
                      class="connection-checkbox-item"
                      [class.is-lead]="connection.is_lead"
                      [attr.title]="
                        connection.is_lead
                          ? 'The business is an active lead of this CDFI'
                          : ''
                      "
                    >
                      <input
                        type="checkbox"
                        [(ngModel)]="connectionCheckboxState[connection.id]"
                        (change)="onConnectionSelection($event, connection.id)"
                        [disabled]="connection.is_lead"
                      />
                      <span class="checkbox-custom"></span>
                      <span class="connection-label-text">
                        {{
                          connection.display_name || connection.connection_name
                        }}
                      </span>
                      @if (connection.is_lead) {
                        <app-svg-icon
                          class="lead-lock-icon"
                          [iconName]="'lead-lock.svg'"
                          [width]="'14px'"
                          [height]="'14px'"
                        ></app-svg-icon>
                        <span class="lead-badge">Lead</span>
                      }
                    </label>
                  }
                  @if (hasMoreConnections) {
                    <button
                      class="load-more-button"
                      [class.loading]="isLoadingMore"
                      (click)="loadConnections(true)"
                    >
                      @if (isLoadingMore) {
                        <app-svg-icon
                          class="spinner-icon"
                          [iconName]="'spinner.svg'"
                          [width]="'16px'"
                          [height]="'16px'"
                        ></app-svg-icon>
                      }
                      {{ isLoadingMore ? "Loading..." : "Load More" }}
                    </button>
                  }
                } @else {
                  <div class="empty-message">
                    <app-svg-icon
                      [iconName]="'search-solid.svg'"
                      [width]="'48px'"
                      [height]="'48px'"
                      [style.fill]="'#9ca3af'"
                    ></app-svg-icon>
                    <p>No CDFIs found</p>
                  </div>
                }
              } @else {
                <div class="loading-message">
                  <app-svg-icon
                    class="spinner-icon"
                    [iconName]="'spinner.svg'"
                    [width]="'40px'"
                    [height]="'40px'"
                  ></app-svg-icon>
                  <p>Loading CDFIs...</p>
                </div>
              }
            </div>
          </div>
        }

        <!-- Current Access Section (moved to bottom) -->
        @if (
          visibilityMode === recordVisibilityModes.Restricted &&
          visibleConnections.length > 0
        ) {
          <div class="current-access-section">
            <h3>Currently Shared With</h3>
            <div class="current-connections">
              @for (assignee of visibleConnections; track $index) {
                <div
                  class="connection-badge"
                  [class.is-lead]="assignee.is_lead"
                  [class.is-removed]="
                    !assignee.is_lead && connectionsToExclude.has(assignee.id)
                  "
                >
                  @if (assignee.is_lead) {
                    <app-svg-icon
                      class="lead-lock-icon"
                      [iconName]="'lead-lock.svg'"
                      [width]="'14px'"
                      [height]="'14px'"
                    ></app-svg-icon>
                  } @else {
                    <app-svg-icon
                      [iconName]="'user-solid.svg'"
                      [width]="'14px'"
                      [height]="'14px'"
                    ></app-svg-icon>
                  }
                  <span>{{
                    assignee.display_name || assignee.connection_name
                  }}</span>
                  @if (!assignee.is_lead) {
                    @if (connectionsToExclude.has(assignee.id)) {
                      <button
                        class="revert-connection-btn"
                        (click)="restoreConnection(assignee.id)"
                        aria-label="Restore connection"
                      >
                        <app-svg-icon
                          [iconName]="'revert.svg'"
                          [width]="'10px'"
                          [height]="'10px'"
                        ></app-svg-icon>
                      </button>
                    } @else {
                      <button
                        class="remove-connection-btn"
                        (click)="removeConnection(assignee.id)"
                        aria-label="Remove connection"
                      >
                        <app-svg-icon
                          [iconName]="'times.svg'"
                          [width]="'10px'"
                          [height]="'10px'"
                        ></app-svg-icon>
                      </button>
                    }
                  }
                </div>
              }
            </div>
          </div>
        }
      } @else {
        <div class="confirmation-summary">
          <!-- Mode Transition Card -->
          <div class="warning-box">
            <div class="warning-icon-wrapper">
              <app-svg-icon
                [iconName]="'warning-circle.svg'"
                [width]="'18px'"
                [height]="'18px'"
                [style.fill]="'#d97706'"
              ></app-svg-icon>
            </div>
            <p>This action will send notifications to affected users.</p>
          </div>
          <div
            class="mode-transition-card"
            [class.single-state]="previousVisibilityMode === visibilityMode"
          >
            @if (previousVisibilityMode !== visibilityMode) {
              <div class="mode-state from">
                <div class="mode-icon-wrapper">
                  @if (
                    previousVisibilityMode === recordVisibilityModes.Public
                  ) {
                    <app-svg-icon
                      [iconName]="'globe.svg'"
                      [width]="'20px'"
                      [height]="'20px'"
                      [style.fill]="'#334ea5'"
                    ></app-svg-icon>
                  } @else if (
                    previousVisibilityMode === recordVisibilityModes.Private
                  ) {
                    <app-svg-icon
                      [iconName]="'private-lock.svg'"
                      [width]="'20px'"
                      [height]="'20px'"
                      [style.fill]="'#334ea5'"
                    ></app-svg-icon>
                  } @else {
                    <app-svg-icon
                      [iconName]="'restricted-users.svg'"
                      [width]="'20px'"
                      [height]="'20px'"
                      [style.fill]="'#334ea5'"
                    ></app-svg-icon>
                  }
                </div>
                <span class="mode-name">{{
                  recordVisibilityModes[previousVisibilityMode]
                }}</span>
              </div>

              <div class="transition-arrow">
                <app-svg-icon
                  [iconName]="'arrow-right.svg'"
                  [width]="'16px'"
                  [height]="'16px'"
                  [style.fill]="'#334ea5'"
                ></app-svg-icon>
              </div>

              <div class="mode-state to">
                <div class="mode-icon-wrapper">
                  @if (visibilityMode === recordVisibilityModes.Public) {
                    <app-svg-icon
                      [iconName]="'globe.svg'"
                      [width]="'20px'"
                      [height]="'20px'"
                      [style.fill]="'#334ea5'"
                    ></app-svg-icon>
                  } @else if (
                    visibilityMode === recordVisibilityModes.Private
                  ) {
                    <app-svg-icon
                      [iconName]="'private-lock.svg'"
                      [width]="'20px'"
                      [height]="'20px'"
                      [style.fill]="'#334ea5'"
                    ></app-svg-icon>
                  } @else {
                    <app-svg-icon
                      [iconName]="'restricted-users.svg'"
                      [width]="'20px'"
                      [height]="'20px'"
                      [style.fill]="'#334ea5'"
                    ></app-svg-icon>
                  }
                </div>
                <span class="mode-name">{{
                  recordVisibilityModes[visibilityMode]
                }}</span>
              </div>
            } @else {
              <div class="mode-state current">
                <div class="mode-icon-wrapper">
                  <app-svg-icon
                    [iconName]="'restricted-users.svg'"
                    [width]="'24px'"
                    [height]="'24px'"
                    [style.fill]="'#334ea5'"
                  ></app-svg-icon>
                </div>
                <span class="mode-name">{{
                  recordVisibilityModes[visibilityMode]
                }}</span>
              </div>
            }

            <div class="transition-message">
              <div class="transition-title">
                {{
                  previousVisibilityMode !== visibilityMode
                    ? "Changing from " +
                      recordVisibilityModes[previousVisibilityMode] +
                      " to " +
                      recordVisibilityModes[visibilityMode]
                    : "Updating " +
                      recordVisibilityModes[visibilityMode] +
                      " Mode"
                }}
              </div>
              <p>{{ summaryModeMessage }}</p>
            </div>
          </div>

          @if (visibilityMode === recordVisibilityModes.Restricted) {
            <div class="summary-columns">
              <div class="summary-column gain-access">
                <div class="column-header">
                  <div class="header-title">
                    <div class="icon-circle">
                      <app-svg-icon
                        [iconName]="'plus.svg'"
                        [width]="'12px'"
                        [height]="'12px'"
                        [style.fill]="'#334ea5'"
                      ></app-svg-icon>
                    </div>
                    <span>Will gain access</span>
                  </div>
                  <span
                    class="count-badge"
                    [class.has-items]="summaryAddedConnections.length > 0"
                  >
                    {{ summaryAddedConnections.length }}
                  </span>
                </div>

                @if (summaryAddedConnections.length === 0) {
                  <div class="empty-state">
                    <span class="dot"></span>
                    No new connections
                  </div>
                } @else {
                  <ul class="summary-list">
                    @for (item of summaryAddedConnections; track item.id) {
                      <li [class.item-is-lead]="item.isLead">
                        <div class="item-avatar">
                          <span>{{ item.name.charAt(0).toUpperCase() }}</span>
                        </div>
                        <span class="connection-name" [title]="item.name">{{
                          item.name
                        }}</span>
                        @if (item.isLead) {
                          <span class="lead-tag">Lead</span>
                        }
                      </li>
                    }
                  </ul>
                }
              </div>

              <div class="summary-column lose-access">
                <div class="column-header">
                  <div class="header-title">
                    <div class="icon-circle">
                      <app-svg-icon
                        [iconName]="'minus.svg'"
                        [width]="'12px'"
                        [height]="'12px'"
                        [style.fill]="'#d97706'"
                      ></app-svg-icon>
                    </div>
                    <span>Will lose access</span>
                  </div>
                  <span
                    class="count-badge"
                    [class.has-items]="summaryRemovedConnections.length > 0"
                  >
                    {{ summaryRemovedConnections.length }}
                  </span>
                </div>

                @if (summaryRemovedConnections.length === 0) {
                  <div class="empty-state">
                    <span class="dot"></span>
                    No connections lost
                  </div>
                } @else {
                  <ul class="summary-list">
                    @for (item of summaryRemovedConnections; track item.id) {
                      <li [class.item-is-lead]="item.isLead">
                        <div class="item-avatar">
                          <span>{{ item.name.charAt(0).toUpperCase() }}</span>
                        </div>
                        <span class="connection-name" [title]="item.name">{{
                          item.name
                        }}</span>
                        @if (item.isLead) {
                          <span class="lead-tag">Lead</span>
                        }
                      </li>
                    }
                  </ul>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>

    <div class="modal-footer">
      @if (visibilityError) {
        <div class="error-message">
          <app-svg-icon
            [iconName]="'warning-circle.svg'"
            [width]="'16px'"
            [height]="'16px'"
          ></app-svg-icon>
          <span>{{ visibilityError }}</span>
          <button
            class="dismiss-error"
            (click)="visibilityError = null"
            aria-label="Dismiss error"
          >
            <app-svg-icon
              [iconName]="'times.svg'"
              [width]="'12px'"
              [height]="'12px'"
            ></app-svg-icon>
          </button>
        </div>
      }

      <div class="footer-buttons">
        @if (!showConfirmation) {
          <button class="cancel-btn" (click)="closeModal()">Cancel</button>
          <button
            class="save-btn-modal"
            (click)="initiateSave()"
            [disabled]="!hasChanges()"
          >
            <app-svg-icon
              [iconName]="'check-simple.svg'"
              [width]="'14px'"
              [height]="'14px'"
            ></app-svg-icon>
            Review
          </button>
        } @else {
          <button class="cancel-btn" (click)="cancelConfirmation()">
            Back to edit
          </button>
          <button class="save-btn-modal" (click)="confirmSave()">
            Confirm & Notify
          </button>
        }
      </div>
    </div>
  </div>
</div>
